/**
 * CategoryRegistry — the single lookup table for category plugins.
 * Adding a new category means writing a plugin module and registering it here.
 * See AP-10 (Plugin Contract) and AP-11 (Configuration-First) in Documents 4 and 5.
 */
import type { CategoryId, CategoryPlugin } from "./plugin";

import { plugin as personalPerfumes }    from "./plugins/personal-perfumes";
import { plugin as carPerfumes }         from "./plugins/car-perfumes";
import { plugin as diffusers }           from "./plugins/diffusers";
import { plugin as homeOfficeDiffusers } from "./plugins/home-office-diffusers";
import { plugin as solidPerfumes }       from "./plugins/solid-perfumes";
import { plugin as rollOnPerfumes }      from "./plugins/roll-on-perfumes";
import { plugin as perfumeOils }         from "./plugins/perfume-oils";
import { plugin as scentedSticks }       from "./plugins/scented-sticks";
import { plugin as futureCollections }   from "./plugins/future-collections";

const REGISTRY: Record<CategoryId, CategoryPlugin> = {
  "personal-perfumes":     personalPerfumes,
  "car-perfumes":          carPerfumes,
  "diffusers":             diffusers,
  "home-office-diffusers": homeOfficeDiffusers,
  "solid-perfumes":        solidPerfumes,
  "roll-on-perfumes":      rollOnPerfumes,
  "perfume-oils":          perfumeOils,
  "scented-sticks":        scentedSticks,
  "future-collections":    futureCollections,
};

export const CategoryRegistry = {
  ids(): CategoryId[] { return Object.keys(REGISTRY) as CategoryId[]; },
  all(): CategoryPlugin[] { return Object.values(REGISTRY); },
  get(id: string): CategoryPlugin | undefined { return REGISTRY[id as CategoryId]; },
  getBySlug(slug: string): CategoryPlugin | undefined {
    return Object.values(REGISTRY).find((p) => p.metadata.slug === slug);
  },
  has(id: string): boolean { return id in REGISTRY; },
};

export type { CategoryPlugin, CategoryId } from "./plugin";
